import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: "active",
    routes: [
        {
            path: '/',
            name: 'landingpage',
            component: () => import(/* webpackChunkName: "home" */ './views/LandingPage.vue'),
        },
        {
            path: '/measurement/index',
            redirect: 'measurement/index',
            component: () => import(/* webpackChunkName: "dashboard" */ './layout/dashboard/DashboardLayout.vue'),
            children: [
                //User module
                {
                    path: '/user/index',
                    name: 'userIndex',
                    meta: {
                        title: 'OverviewUsers',
                    },
                    component: () => import(/* webpackChunkName: "userIndex" */ './views/user/Index.vue')
                },
                {
                    path: '/user/create',
                    name: 'userCreate',
                    meta: {
                        title: 'CreateUser',
                    },
                    component: () => import(/* webpackChunkName: "userCreate" */ './views/user/Form.vue')
                },
                {
                    path: '/user/update/:id',
                    name: 'userUpdate',
                    meta: {
                        title: 'UpdateUser',
                    },
                    component: () => import(/* webpackChunkName: "userUpdate" */ './views/user/Form.vue')
                },
                //Apps module
                {
                    path: '/apps/index',
                    name: 'appIndex',
                    component: () => import(/* webpackChunkName: "appIndex" */ './views/apps/Index.vue')
                },
                {
                    path: '/apps/create',
                    name: 'appCreate',
                    component: () => import(/* webpackChunkName: "appCreate" */ './views/apps/Create.vue')
                },
                {
                    path: '/apps/update/:id',
                    name: 'appUpdate',
                    component: () => import(/* webpackChunkName: "appUpdate" */ './views/apps/Update.vue')
                },
                //Measurement module
                {
                    path: '/measurement/index',
                    name: 'measurementIndex',
                    meta: {
                        title: 'OverviewMeasurements',
                    },
                    component: () => import(/* webpackChunkName: "measurementIndex" */ './views/measurement/Index.vue')
                },
                {
                    path: '/measurement/monitoring',
                    name: 'measurementMonitoring',
                    meta: {
                        title: 'MonitoringMeasurements',
                    },
                    component: () => import(/* webpackChunkName: "measurementIndex" */ './views/measurement/Monitoring.vue')
                },
                {
                    path: '/measurement/create',
                    name: 'measurementCreate',
                    meta: {
                        title: 'NewMeasurement',
                    },
                    component: () => import(/* webpackChunkName: "measurementCreate" */ './views/measurement/Form.vue')
                },
                {
                    path: '/customers/:customer_id/components/:component_id/measurements/:id',
                    name: 'measurementUpdate',
                    meta: {
                        title: 'UpdateMeasurement',
                    },
                    component: () => import(/* webpackChunkName: "measurementUpdate" */ './views/measurement/Form.vue')
                },
                //Component module
                {
                    path: '/component/index',
                    name: 'componentIndex',
                    meta: {
                        title: 'OverviewComponents',
                    },
                    component: () => import(/* webpackChunkName: "componentIndex" */ './views/component/Index.vue')
                },
                {
                    path: '/component/create',
                    name: 'componentCreate',
                    meta: {
                        title: 'NewComponent',
                    },
                    component: () => import(/* webpackChunkName: "componentCreate" */ './views/component/Form.vue')
                },
                {
                    path: '/customers/:customer_id/components/:id',
                    name: 'componentUpdate',
                    meta: {
                        title: 'UpdateComponent',
                    },
                    component: () => import(/* webpackChunkName: "componentUpdate" */ './views/component/Form.vue')
                },
                {
                    path: '/customers/:customer_id/components/view/:id',
                    name: 'componentView',
                    meta: {
                        title: 'ViewComponent',
                    },
                    component: () => import(/* webpackChunkName: "componentView" */ './views/component/View.vue')
                },
                //ComponentType module
                {
                    path: '/componenttype/index',
                    name: 'componenttypeIndex',
                    meta: {
                        title: 'OverviewComponenttypes',
                    },
                    component: () => import(/* webpackChunkName: "componenttypeIndex" */ './views/componenttype/Index.vue')
                },
                {
                    path: '/componenttype/create',
                    name: 'componenttypeCreate',
                    meta: {
                        title: 'NewComponenttype',
                    },
                    component: () => import(/* webpackChunkName: "componenttypeCreate" */ './views/componenttype/Form.vue')
                },
                {
                    path: '/componenttype/update/:id',
                    name: 'componenttypeUpdate',
                    meta: {
                        title: 'UpdateComponenttype',
                    },
                    component: () => import(/* webpackChunkName: "componenttypeUpdate" */ './views/componenttype/Form.vue')
                },
                //Brand module
                {
                    path: '/brand/index',
                    name: 'brandIndex',
                    meta: {
                        title: 'OverviewBrands',
                    },
                    component: () => import(/* webpackChunkName: "brandIndex" */ './views/brand/Index.vue')
                },
                {
                    path: '/brand/create',
                    name: 'brandCreate',
                    meta: {
                        title: 'NewBrand',
                    },
                    component: () => import(/* webpackChunkName: "brandCreate" */ './views/brand/Form.vue')
                },
                {
                    path: '/brand/update/:id',
                    name: 'brandUpdate',
                    meta: {
                        title: 'UpdateBrand',
                    },
                    component: () => import(/* webpackChunkName: "brandUpdate" */ './views/brand/Form.vue')
                },
                //Customer module
                {
                    path: '/customer/index',
                    name: 'customerIndex',
                    meta: {
                        title: 'OverviewCustomer',
                    },
                    component: () => import(/* webpackChunkName: "customerIndex" */ './views/customer/Index.vue')
                },
                {
                    path: '/customer/create',
                    name: 'customerCreate',
                    meta: {
                        title: 'NewCustomer',
                    },
                    component: () => import(/* webpackChunkName: "customerCreate" */ './views/customer/Form.vue')
                },
                {
                    path: '/customer/update/:id',
                    name: 'customerUpdate',
                    meta: {
                        title: 'UpdateCustomer',
                    },
                    component: () => import(/* webpackChunkName: "customerUpdate" */ './views/customer/Form.vue')
                }
            ]

        },
        {
            path: '/login',
            component: () => import(/* webpackChunkName: "layoutLogin" */ './views/LayoutLogin.vue'),
            children: [
                {
                    path: '/login',
                    name: 'login',
                    // route level code-splitting
                    // this generates a separate chunk (about.[hash].js) for this route
                    // which is lazy-loaded when the route is visited.
                    component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
                },
                {
                    path: '/forgot',
                    name: 'forgot',
                    component: () => import(/* webpackChunkName: "forgot" */ './views/password/Forgot.vue')
                },
                {
                    path: '/reset',
                    name: 'reset',
                    component: () => import(/* webpackChunkName: "reset" */ './views/password/Reset.vue')
                }
            ]

        },
        {
            path: '*',
            redirect: '/'
        }
    ]
})

// redirect to login page if not logged in and trying to access a restricted page
router.beforeEach((to, from, next) => {
    const publicPages = ['/login', '/forgot', '/reset', '/'];
    const authRequired = !publicPages.includes(to.path);
    let loggedIn = store.getters.isAuthenticated;

    //Niet toegelaten -> redirect naar login
    if (authRequired && !loggedIn) {
        next({
            name: 'landingpage'
        })
        //Toegelaten en op login pagina -> redirect naar dashboard
    } else if ('/login' === to.path && loggedIn) {
        next({
            name: 'measurementIndex'
        })
        //Toegelaten
    } else if (loggedIn) {
        next()
    } else {
        next()
    }
})

export default router
